import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import LocationFill from '@icons/LocationFill';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';

import styles from './styles.module.scss';

function Shop() {
  const { shopName } = useCalculatedRequest();
  return (
        <Row className={styles.container} >
            <LocationFill color={colors.gray6}
                          style={{ marginRight: 4 }}/>
            <TextUnderline>
                <Text size='lg' fontWeight='bold'>{shopName}</Text>
            </TextUnderline>
            <Text size='lg'>에서 주문할게요</Text>
        </Row>
  );
}

export default Shop;
